import { useEffect } from 'react'

import { useProgressAnimation } from '~/shared/hooks/useProgressAnimation'

interface Params {
  goToNextPage: VoidFunction
  STATIC_ANIMATION_DURATION: number
}

export const useProgressAnimationData = ({
  goToNextPage,
  STATIC_ANIMATION_DURATION,
}: Params) => {
  const {
    counter: firstCounter,
    isFinished: isFirstCounterFinished,
    progressAnimationPlayback: firstProgressAnimationPlayback,
  } = useProgressAnimation({
    duration: STATIC_ANIMATION_DURATION,
  })

  const {
    counter: secondCounter,
    isFinished: isSecondCounterFinished,
    progressAnimationPlayback: secondProgressAnimationPlayback,
  } = useProgressAnimation({
    duration: STATIC_ANIMATION_DURATION,
  })

  const {
    counter: thirdCounter,
    isFinished: isThirdCounterFinished,
    progressAnimationPlayback: thirdProgressAnimationPlayback,
  } = useProgressAnimation({
    duration: STATIC_ANIMATION_DURATION,
  })

  const {
    counter: fourthCounter,
    isFinished: isFourthCounterFinished,
    progressAnimationPlayback: fourthProgressAnimationPlayback,
  } = useProgressAnimation({
    duration: STATIC_ANIMATION_DURATION,
    callback: goToNextPage,
  })

  useEffect(() => {
    firstProgressAnimationPlayback()
  }, [firstProgressAnimationPlayback])

  useEffect(() => {
    isFirstCounterFinished && secondProgressAnimationPlayback()
  }, [isFirstCounterFinished, secondProgressAnimationPlayback])

  useEffect(() => {
    isSecondCounterFinished && thirdProgressAnimationPlayback()
  }, [isSecondCounterFinished, thirdProgressAnimationPlayback])

  useEffect(() => {
    isThirdCounterFinished && fourthProgressAnimationPlayback()
  }, [isThirdCounterFinished, fourthProgressAnimationPlayback])

  return {
    firstCounter,
    isFirstCounterFinished,
    secondCounter,
    isSecondCounterFinished,
    secondProgressAnimationPlayback,
    thirdCounter,
    isThirdCounterFinished,
    thirdProgressAnimationPlayback,
    fourthCounter,
    isFourthCounterFinished,
  }
}
